import { Box } from "@mui/material";

export function CustomIconButton({ height = "30px", width = "30px", src,backgroundColor="#2A6ED4",onClick}) {
    return <Box onClick={onClick} sx={{borderRadius:"5.83px", display: "flex", justifyContent: "center", alignItems: "center", height: height, width: width,backgroundColor:backgroundColor,cursor:"pointer"}}>
        <img style={{width:"13px",height:"13px"}} src={src} />
    </Box>
}